<ng-container *ngIf="!loading; else loadingTemplate">
  <ng-container *ngIf="barChartData?.length || cumulativeBarChartData?.length; else empty">
    <ng-container [ngSwitch]="chartType">
      <ng-container *ngSwitchCase="'bar'">
        <ngx-charts-bar-vertical-stacked
          [scheme]="colorScheme"
          [view]="view"
          [results]="barChartData"
          [showDataLabel]="true"
          [dataLabelFormatting]="formatDataLabel"
          [xAxis]="true"
          [yAxis]="true"
          [showXAxisLabel]="true"
          [showYAxisLabel]="true"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [xAxisTickFormatting]="xAxisTickFormatter"
          [animations]="true"
          [barPadding]="barPadding || 8"
          [legend]="showLegend"
          [legendTitle]="''"
          legendPosition="below"
        >
          <ng-template #tooltipTemplate let-model="model">
            <div *ngIf="model.label">{{ model.label }}</div>
            <div>{{ xAxisTooltipFormatter(model.series) }}</div>
            <div>
              <strong>{{ model.value }}</strong>
            </div>
          </ng-template>
        </ngx-charts-bar-vertical-stacked>
      </ng-container>
      <ng-container *ngSwitchCase="'cumulative'">
        <ngx-charts-bar-vertical-stacked
          [scheme]="colorScheme"
          [view]="view"
          [results]="cumulativeBarChartData"
          [dataLabelFormatting]="formatDataLabel"
          [showDataLabel]="true"
          [xAxis]="true"
          [yAxis]="true"
          [showYAxisLabel]="true"
          [showYAxisLabel]="true"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [xAxisTickFormatting]="xAxisTickFormatter"
          [animations]="true"
          [barPadding]="barPadding || 8"
          [legend]="showLegend"
          [legendTitle]="''"
          legendPosition="below"
        >
          <ng-template #tooltipTemplate let-model="model">
            <div *ngIf="model.label">{{ model.label }}</div>
            <div>{{ xAxisTooltipFormatter(model.series) }}</div>
            <div>
              <strong>{{ model.value }}</strong>
            </div>
          </ng-template>
        </ngx-charts-bar-vertical-stacked>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>

<ng-template #empty>
  <div class="empty">
    <img
      class="empty-placeholder"
      alt="Empty Bar chart"
      src="./assets/images/analytics/chart-bar-empty-state.svg"
    />
    <span i18n>No data to display</span>
  </div>
</ng-template>
